
import Vue from 'vue';
import Component from "vue-class-component";
import { ILocker } from "@/model/Locker/lockerInterfaces";
import { namespace } from "vuex-class";
import { IShortLocker } from "@/model/shortInterfaces";
import {Prop, Watch} from "vue-property-decorator";
import { IErrors } from "@/model/IErrors";
import {IOnOffHandlers} from "bonomo/dist";

const lockerModule = namespace("lockerModule");

@Component
export default class LockerSearch extends Vue {
  @lockerModule.Getter('lockers')
  private lockers!: ILocker[];

  @lockerModule.Action('fetchLockers')
  private fetchLockers!: () => void;

  @Prop() value!: any;
  @Prop({default: false}) erasable!: boolean;
  @Prop() filterFn!: (each: IShortLocker) => boolean;
  @Prop() errorMessages!: IErrors[];
  @Prop({ default: false }) disabled!: boolean;

  model!: number;
  subscribes: IOnOffHandlers = {};

  private selectedId: number = 0;

  get isErasable(): boolean {
    return this.erasable !== false;
  }

  get lockerItems() {
    const lockers = this.lockers;
    let ret: any = (lockers || []);
    if (this.filterFn) {
      ret = ret.filter(this.filterFn);
    }
    ret = ret.map((locker: ILocker) => ({
      text: locker.name + ' (#' + locker.id + ')',
      value: locker.id,
    }));
    ret.unshift({
      text: '',
      value: 0,
    });
    return ret;
  }

  // value might change from the outside, especially on initial load, keep it synced
  @Watch('value')
  onValueChanged(newValue: number) {
    this.model = newValue;
  }

  created() {
    if (!this.lockers || !this.lockers.length) {
      this.fetchLockers();
    }
    this.model = this.value;
  }

  onEraseClicked() {
    if (this.isErasable) {
      this.selectedId = 0;
      this.$emit('onLockerSelected', null);
    }
    else {
      // @todo activate dropdown from here?
      return true;
    }
  }

  onLockerSelected(newLockerId: number) {
    if (!this.disabled) {
      this.$emit('onLockerSelected', newLockerId);
    }
  }
}
